import { RelationshipType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";

export const orgRelationships = [
  RelationshipType.Managing,
  RelationshipType.PartOf
];
